import React, { Component } from 'react';
import '../css/subItemInfo.css';

export class SubItemInfo extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        var test = "";
        var oldItemOptions = this.props.oldItem.itemOptions.split(",");
        var newItemOptions = this.props.newItem.itemOptions.split(",");
        return (
            <div className='subItemInfo'>
                <b>{this.props.newItem.displayName}</b>
                <table className='subInfoTable'>
                    <th>Item</th>
                    <th>Options</th>
                    {
                        <tr>
                            <td>Original</td>
                            <td>
                                <ul className='subInfoList org-item'>
                                    {oldItemOptions.map(function (option, idx) {
                                        return (
                                            <b>{option}</b>
                                        )
                                    })}
                                </ul>
                            </td>
                        </tr>
                    }
                    {
                        <tr>
                            <td>To Sub</td>
                            <td>
                                <ul className='subInfoList new-item'>
                                    {newItemOptions.map(function (option, idx) {
                                        return (
                                            <b>{option}</b>
                                        )
                                    })}
                                </ul>
                            </td>
                        </tr>
                    }
                </table>
                <b>Would you like to substitute?</b>
            </div>
        );
    }
}
